// Module
var code = "<script>let $ctrl</script> <div class=\"molecule-panel-edit-row molecule-panel-edit-row-info\" ng-class=\"{ 'grow-children': $ctrl.grow }\"> <ng-transclude class=\"{{ $ctrl.className }}\"></ng-transclude> </div> ";
// Exports
module.exports = code;